export function countAllNestedItems (item) {
  let count = 0

  function recurse (node) {
    if (Array.isArray(node)) {
      // If it's an array, iterate over each element and recurse
      node.forEach(element => recurse(element))
    } else if (typeof node === 'object' && node !== null) {
      count++ // Count the current parent object
      for (const key in node) {
        recurse(node[key]) // Recurse into its children
      }
    } else if (typeof node === 'string') {
      count++ // Count the string (leaf node)
    }
  }

  recurse(item) // Start the recursion

  return count
}

export function generateRandomId () {
  return 'id-' + Math.random().toString(36).substr(2, 9)
}

export function composeUrlFromArray (parts) {
  return `/${parts.filter(Boolean).join('/')}`
}

export function sleep (ms = 0) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export function getCookiesWithPrefix (prefix) {
  if (!document?.cookie) {
    return []
  }

  const cookieNames = document.cookie.split(/=[^;]*(?:;\s*|$)/)

  return cookieNames
    .filter(name => name.startsWith(prefix))
}
